// extracted by mini-css-extract-plugin
export default {"imageWrapper":"rE-z","hovered":"sE-z","hoverImage":"tE-z","mainImage":"uE-z","imageNoBackground":"vE-z","fullSizeImage":"wE-z"};